import dayjs from "dayjs"
import { businessTimeZone } from "../../utils/date"

// WS 2074858. The two dates the Reschedule window works out for the operator, as YYYY-MM-DD
// business-time calendar days (the server checks "not in the past" in business time too).
// "End of program" is one gap of the declined payment's own frequency after the client's last
// payment, or after today when every payment is already behind.
const addOneGap = (date, frequency) => {
  switch (frequency) {
    case 'weekly':
      return date.add(1, 'week')
    case 'every2':
    case 'biweekly':
      return date.add(2, 'week')
    case 'semiMonthly':
      return date.add(15, 'day')
    default:
      return date.add(1, 'month')
  }
}

export const rescheduleDates = ({ payment, payments = [], today = dayjs().tz(businessTimeZone) }) => {
  const start = today.tz(businessTimeZone).startOf('day')
  const lastDue = payments
    .map((row) => row?.dueDate)
    .filter(Boolean)
    .map((dueDate) => dayjs(dueDate).tz(businessTimeZone).startOf('day'))
    .reduce((latest, dueDate) => (dueDate.isAfter(latest) ? dueDate : latest), start)

  return {
    endOfProgram: addOneGap(lastDue, payment?.frequency).format('YYYY-MM-DD'),
    nextWeek: start.add(1, 'week').format('YYYY-MM-DD'),
  }
}
